/**
 * baseClass.ts  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM, IBemModifiersMap } from "@adapptio/lib-components";

export const getBaseClass = (elementName?: string, modifiers?: IBemModifiersMap) =>
	BEM("edt-table", elementName, modifiers);
